import type { PropsWithChildren } from "react";
import { PortalHost, PortalProvider } from "react-native-teleport";
import { StyleSheet } from "react-native-unistyles";

import { MODAL_PORTAL_HOST } from "$src/core/constants/portal";

/**
 * Wraps the app in react-native-teleport's portal provider and mounts the
 * shared modal host. Used on iOS, Android and web.
 */
const PortalBoundary = ({ children }: PropsWithChildren) => (
  <PortalProvider>
    {children}
    <PortalHost
      style={StyleSheet.absoluteFillObject}
      name={MODAL_PORTAL_HOST}
    />
  </PortalProvider>
);

export default PortalBoundary;
